// extracted by mini-css-extract-plugin
export var button = "hoverCardGrid-module--button--f0a6a";
export var buttonWrapper = "hoverCardGrid-module--buttonWrapper--9a222";
export var card = "hoverCardGrid-module--card--89738";
export var cardDescription = "hoverCardGrid-module--cardDescription--8320b";
export var cardTitle = "hoverCardGrid-module--cardTitle--39267";
export var description = "hoverCardGrid-module--description--bca25";
export var grid = "hoverCardGrid-module--grid--eb536";
export var headline = "hoverCardGrid-module--headline--d3657";
export var hoverCardGrid = "hoverCardGrid-module--hoverCardGrid--01329";
export var image = "hoverCardGrid-module--image--815c5";
export var imageWrapper = "hoverCardGrid-module--imageWrapper--b9f9b";
export var inner = "hoverCardGrid-module--inner--8e12b";